import { SERVER_URL } from "../../api";
import axios from 'axios';
import { getHeaderWithToken } from "../../helpers/func";

export const CLONE_SUPPLY_REQUEST = 'CLONE_SUPPLY_REQUEST';
export const CLONE_SUPPLY_SUCCESS = 'CLONE_SUPPLY_SUCCESS';
export const CLONE_SUPPLY_ERROR = 'CLONE_SUPPLY_ERROR';


export const cloneSupply = (id) => {
    let headers = getHeaderWithToken();

    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: CLONE_SUPPLY_REQUEST
            })
            axios({
                method: 'POST',
                url: `${SERVER_URL}v1/supply/${id}/clone`,
                headers: headers,
            }).then(function (response) {
                dispatch({
                    type: CLONE_SUPPLY_SUCCESS,
                    payload: response
                })
                resolve(response);
            })
                .catch(function (error) {
                    dispatch({
                        type: CLONE_SUPPLY_ERROR,
                        payload: error
                    })
                    reject(error)
                })
        })
    }
}
